export default "__VITE_ASSET__db852271__"